import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { ButtonComponent } from '../../../../common/components/button/button.component';
import { FormsModule } from '@angular/forms';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';

@Component({
  selector: 'app-change-status-dialog',
  standalone: true,
  imports: [MatDialogModule, CommonModule, MatButtonModule, ButtonComponent, FormsModule, NgMultiSelectDropDownModule],
  templateUrl: './change-status-dialog.component.html',
  styleUrl: './change-status-dialog.component.scss'
})
export class ChangeStatusDialogComponent {

  statusList: any = [
    { item_id: 1, item_text: 'Active' },
    { item_id: 2, item_text: 'Inactive' },
  ];

  selectedStatus: string = '';
  formSubmitted: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<ChangeStatusDialogComponent>,
  ) {

  }

  close() {
    this.formSubmitted = false;
    this.dialogRef.close();
  }
  
  submit() {
    this.formSubmitted = true;
    if (!this.selectedStatus) {
      return
    }
    this.dialogRef.close(this.selectedStatus);
  }

}
